import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoStatsDataSlide.styles";

export const NoStatsDataSlide = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <AutoGraphOutlinedIcon className={classes.icon} />
            <Typography variant="h1" className={classes.title}>
                {t("HMI.stats-not-enough-data.title")}
            </Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
                {t("HMI.stats-not-enough-data.subtitle")}
            </Typography>
        </Box>
    );
};
